export default '/pricing/yuno/payment';
